'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var sdk_1 = require("@builder.io/sdk");
// Allow us to require things dynamically safe from webpack bundling
exports.safeDynamicRequire = sdk_1.Builder.isServer
    ? eval('require')
    : (function () { return null; });
//# sourceMappingURL=safe-dynamic-require.js.map